import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectTFAStatus,
  selectTFAStatusLoading,
  selectTFAStatusState,
  useFetchTFAStatusQuery,
  useLazyFetchTFAStatusQuery,
} from '../fetchTFAStatus';

export interface IUseTFAStatusQueryProps extends IUseQueryProps {}

export const useTFAStatusQuery = ({
  skipFetching,
}: IUseTFAStatusQueryProps = {}) => {
  useFetchTFAStatusQuery(getQueryParams({ params: undefined, skipFetching }));

  const [handleFetchTFAStatus] = useLazyFetchTFAStatusQuery();

  const tfaStatus = useAppSelector(selectTFAStatus);

  const loading = useAppSelector(selectTFAStatusLoading);

  const state = useAppSelector(selectTFAStatusState);

  return { handleFetchTFAStatus, loading, state, tfaStatus };
};
